import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import {
  findObjectUseCase,
  updateObjectUseCase,
} from "../../../../usecases/object";

export default class UnlockingDetailsPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getObject();
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();

    if (id) {
      const params = {
        include: [
          "prev_record_requested",
          "prev_record_requested.lockedTo",
          "requestor.affiliate",
          "requestor.branch",
          "record_requested.lockedTo.affiliate",
          "record_requested.lockedTo.branch",
          "no_record_requested",
          "no_record_requested.lockedTo",
          "record_requested",
          "record_requested.lockedTo",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);

        const accessHistory = await findObjectUseCase().execute(
          "access_history",
          {
            where: {
              record: {
                id: this.object?.no_record
                  ? this.object.no_record_requested?.searchNameId
                  : this.object?.record_requested?.searchNameId,
              },
            },
            limit: 100,
            sort: { createdAt: -1 },
            include: ["accessor.affiliate", "accessor.branch"],
            keys: [
              "accessor",
              "accessor.affiliate",
              "accessor.affiliate.name",
              "accessor.branch",
              "accessor.branch.name",
              "accessor.username",
              "createdAt",
              "searchDT",
              "accessor.firstName",
              "accessor.middleName",
              "accessor.lastName",
            ],
          },
        );
        console.log("ac", accessHistory);
        this.view.setAccessHistory(accessHistory);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async handleApproveRequestClick() {
    await this.view.showApproveRequestModal();
    const user = this.view.getCurrentUser();
    const isAdmin = user?.roles?.some((role) => role.id === "admin");
    const where = {
      status: "Request for Access",
      record_requested: {
        id: this.object?.record_requested?.id,
      },
    };

    if (!isAdmin) {
      where.$or = [
        { approverName: { $exists: true, $eq: user?.id } },
        { "requestor.id": { $exists: true, $eq: user?.id } },
      ];
    }

    const query = {
      where,
      include: ["requestor"],
    };
    // const query = {
    //   where: {
    //     $or: [
    //       { approverName: { $exists: true, $eq: user?.id } },
    //       { "requestor.id": { $exists: true, $eq: user?.id } },
    //     ],
    //     status: "Request for Access",
    //     record_requested: {
    //       id: this.object?.record_requested?.id,
    //     },
    //   },
    //   include: ["requestor"],
    // };
    const findSameRequestor = await findObjectUseCase().execute(
      "access_request",
      query,
    );

    console.log("same requestor", findSameRequestor);

    // Exclude the request currently being approved (Tanaka's)
    const otherRequests = (findSameRequestor || []).filter(
      (req) => req.id !== this.object?.id,
    );

    console.log("otherRequests", otherRequests);

    try {
      // Cancel all sibling requests for the same record_requested
      await Promise.all(
        otherRequests.map((req) =>
          this.upsertUseCase.execute("access_request", {
            id: req.id,
            status: "Cancelled",
          }),
        ),
      );
    } catch (error) {
      this.view.showError(error);
      return;
    }

    const aff = await findObjectUseCase().execute("affiliates", {
      where: { id: user?.affiliate?.id },
    });

    const bran = await findObjectUseCase().execute("branches", {
      where: { id: user?.branch?.id },
    });

    const newObject = {
      ...this.object,
      status: "Request Granted",
    };

    const record = this.object.record_requested;
    const no_record = this.object.no_record_requested;

    const requestor = this.object.requestor;

    newObject.record_requested = {
      id: newObject.record_requested?.id,
    };
    newObject.no_record_requested = {
      id: newObject.no_record_requested?.id,
    };

    newObject.prev_record_requested = {
      ...newObject.prev_record_requested,
      prev: {
        ...(newObject.prev_record_requested?.prev || {}),
        lockedDate: new Date().toISOString(),
        remainLockedDate: newObject.prev_record_requested?.prev?.lockedDate,
        // specificLockDate: newObject.prev_record_requested?.prev?.lockedDate,
      },
    };

    await this.upsertUseCase.execute("access_request", newObject);

    if ("no_record" in this.object && this.object.no_record === true) {
      if (no_record?.id) {
        await updateObjectUseCase().execute("no_records", {
          id: no_record.id,
          lockedDate: new Date().toISOString(),
        });
      }
    } else {
      if (record?.id) {
        await updateObjectUseCase().execute("records", {
          id: record.id,
          lockedDate: new Date().toISOString(),
        });
      }
    }

    newObject.requestor = { id: newObject.requestor?.id };
    requestor.affiliate = { id: requestor.affiliate?.id };
    requestor.branch = { id: requestor.branch?.id };

    try {
      this.view.showProgress();
      // await this.view.showApproveRequestModal();

      newObject.approveDetails = {
        approvedBy:
          user?.firstName && user?.lastName
            ? `${user.firstName} ${user.middleName || ""} ${
                user.lastName
              }`.trim()
            : user?.email || "Unknown",
        dataApproved: new Date().toISOString(),
        affiliate: aff[0]?.code || "none",
        branch: bran[0]?.code || "none",
        remarks: this.change?.approver_remarks,
      };

      if (newObject?.no_record) {
        await this.upsertUseCase.execute("access_request", newObject);

        if (this.object?.no_record_requested?.company) {
          const { company } = no_record;
          const cases = await findObjectUseCase().execute("no_records", {
            where: { company },
          });

          for (const item of cases) {
            await this.upsertUseCase.execute("no_records", {
              ...item,
              lockedTo: { id: requestor?.id },
            });
          }
        } else {
          const { firstName, middleName, lastName, alias, company } = no_record;
          const cases = await findObjectUseCase().execute("no_records", {
            where: { firstName, middleName, lastName, alias, company },
          });

          for (const item of cases) {
            await this.upsertUseCase.execute("no_records", {
              ...item,
              lockedTo: { id: requestor?.id },
            });
          }
        }
      } else {
        await this.upsertUseCase.execute("access_request", newObject);

        if (this.object?.record_requested?.company) {
          const { company } = record;
          const cases = await findObjectUseCase().execute("records", {
            where: { company },
          });

          for (const item of cases) {
            await this.upsertUseCase.execute("records", {
              ...item,
              lockedTo: { id: requestor?.id },
            });
          }
        } else {
          const { firstName, middleName, lastName, alias, company } = record;
          const cases = await findObjectUseCase().execute("records", {
            where: { firstName, middleName, lastName, alias, company },
          });

          for (const item of cases) {
            await this.upsertUseCase.execute("records", {
              ...item,
              lockedTo: { id: requestor?.id },
            });
          }
        }
      }

      this.getObject();
      toast.success("Request Granted!", { position: "top-right" });
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }
}
